import { render, staticRenderFns } from "./recipient-table.vue?vue&type=template&id=504ee72a"
import script from "./recipient-table.vue?vue&type=script&lang=js"
export * from "./recipient-table.vue?vue&type=script&lang=js"
import style0 from "./recipient-table.vue?vue&type=style&index=0&id=504ee72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports